import { HugeiconsIcon } from "@hugeicons/react";
import {
  Cancel01Icon,
  ComputerIcon,
  SmartPhone01Icon,
  RefreshIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { cx } from "shared/utils";
import { ViewMode } from "./types";

export const Toolbar = ({
  viewMode,
  onViewModeChange,
  onRestart,
  onClose
}: {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  onRestart: () => void;
  onClose: () => void;
}) => (
  <header className="h-14 shrink-0 flex items-center justify-between px-4 border-b border-alpha-80">
    <Button
      HugeIcon={Cancel01Icon}
      size={ButtonSize.SM}
      variant={ButtonVariant.BASE}
      onClick={onClose}
    >
      Close
    </Button>

    <div className="flex items-center gap-1 bg-background-900 rounded-lg p-1">
      <button
        type="button"
        onClick={() => onViewModeChange("desktop")}
        className={cx(
          "flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all",
          viewMode === "desktop"
            ? "bg-white shadow-sm text-content-1000"
            : "text-content-300 hover:text-content-700"
        )}
      >
        <HugeiconsIcon icon={ComputerIcon} size={16} strokeWidth={1.5} />
        Desktop
      </button>
      <button
        type="button"
        onClick={() => onViewModeChange("mobile")}
        className={cx(
          "flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-all",
          viewMode === "mobile"
            ? "bg-white shadow-sm text-content-1000"
            : "text-content-300 hover:text-content-700"
        )}
      >
        <HugeiconsIcon icon={SmartPhone01Icon} size={16} strokeWidth={1.5} />
        Mobile
      </button>
    </div>

    <button
      type="button"
      onClick={onRestart}
      className="flex items-center gap-1.5 text-sm font-medium text-content-300 hover:text-content-700 transition-colors"
    >
      <HugeiconsIcon icon={RefreshIcon} size={16} strokeWidth={1.5} />
      Restart
    </button>
  </header>
);
